import script from "./productDisplay.vue?vue&type=script&setup=true&lang=js"
export * from "./productDisplay.vue?vue&type=script&setup=true&lang=js"

import "./productDisplay.vue?vue&type=style&index=0&id=544f5abd&scoped=true&lang=scss"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_e6558ed2e51dee85cd0a9e429c286fa8/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-544f5abd"]])

export default __exports__